import { QuizContainer } from '../components/quiz/QuizContainer';

export function QuizPage() {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Social Style Assessment</h1>
      <QuizContainer />
    </div>
  );
}
